import React, { Component } from "react"
import styled from "styled-components"



const Wrapper = styled.div``

class Deliverylist extends Component {
  render() {
    return (
      <Wrapper className="containers/Deliverylist/Wrapper container">
        <div className="page-title-box">
          <div className="page-title">Deliverylist</div>
        </div>
        <div className="small">Deliverylist bearbeiten.</div>
      </Wrapper>
    )
  }
}

export default Deliverylist
